import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useStatusDataByDeviceId(diagnosticId: string, deviceId: string, fromDate: Date) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery({
    queryKey: ["statusDataDevice", activeSessionId, diagnosticId, deviceId],

    queryFn: async ({ signal }) => {
      return geotabClient.get(
        "StatusData",
        {
          fromDate,
          toDate: new Date(Date.now()),
          diagnosticSearch: { id: diagnosticId },
          deviceSearch: { id: deviceId },
        },
        50000,
        signal,
      );
    },

    enabled: deviceId !== "",
    retry: true,
    refetchInterval: 30000
  });
}
